module.exports = __webpack_public_path__ + "static/img_0173_dpp_optimized-acd43671b915cbae533b94b0fc884711.jpg";